export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56')
];

export const server_loads = [];

export const dictionary = {
		"/": [14],
		"/account": [19],
		"/account/verify-email": [20],
		"/admin": [21,[3]],
		"/admin/blacklist-hits": [37,[3,7]],
		"/admin/invites": [38,[3]],
		"/admin/settings": [39,[3]],
		"/admin/speakers": [40,[3,8]],
		"/admin/speakers/new": [43,[3,8]],
		"/admin/speakers/[speaker_tag]": [41,[3,8,9]],
		"/admin/speakers/[speaker_tag]/edit": [42,[3,8,9]],
		"/admin/stats": [44,[3,10]],
		"/admin/stats/[stream_tag]": [45,[3,10]],
		"/admin/streams": [46,[3,11]],
		"/admin/streams/new": [50,[3,11]],
		"/admin/streams/[stream_tag]": [47,[3,11,12]],
		"/admin/streams/[stream_tag]/edit": [48,[3,11,12]],
		"/admin/streams/[stream_tag]/refresh": [49,[3,11,12]],
		"/admin/[tag]": [22,[3,4]],
		"/admin/[tag]/moderation": [23,[3,4]],
		"/admin/[tag]/overlay": [24,[5]],
		"/admin/[tag]/panel": [25,[3,4]],
		"/admin/[tag]/settings": [26,[3,4,6]],
		"/admin/[tag]/settings/goals": [27,[3,4,6]],
		"/admin/[tag]/settings/image-tips": [28,[3,4,6]],
		"/admin/[tag]/settings/overlay": [29,[3,4,6]],
		"/admin/[tag]/settings/payments": [30,[3,4,6]],
		"/admin/[tag]/settings/show": [31,[3,4,6]],
		"/admin/[tag]/settings/text-tips": [32,[3,4,6]],
		"/admin/[tag]/settings/voice-tips": [33,[3,4,6]],
		"/admin/[tag]/verify-email": [34,[3,4]],
		"/admin/[tag]/voices/new": [36,[3,4]],
		"/admin/[tag]/voices/[voice_tag]": [35,[3,4]],
		"/leaderboard": [51],
		"/onboard": [52,[13]],
		"/privacy": [53],
		"/signin": [54],
		"/submission": [55],
		"/terms": [56],
		"/[tag]": [15,[2]],
		"/[tag]/image": [16,[2]],
		"/[tag]/text": [17,[2]],
		"/[tag]/voice": [18,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';